// src/components/common/Form/SlideWorkout.js
import React from "react";

const SlideWorkout = ({ data, isActive, workoutOptions, onSelect }) => (
  <div className={`carousel-item c-item ${isActive ? "active" : ""}`}>
    <h1 className="display-2 fw-bolder text-capitalize mb-5 hero-title">
      {data.titleBefore} <span className="text-color">{data.titleRed}</span>
      {data.titleAfter}
    </h1>
    <div className="container">
      <div className="row">
        {Object.entries(workoutOptions).map(([key, value], index) => (
          <div className={`col-12 ${Object.keys(workoutOptions).length === 9 ? "col-md-4" : "col-md-3"} mb-2`} key={index}>
            <button type="button" className="custom-btn small position-relative" style={{ paddingBottom: "1.4rem" }} onClick={() => onSelect(key)}>
              {value}
              {data[value] && (
                <span className="position-absolute start-50 bottom-0 translate-middle-x color-light text-nowrap" style={{ fontSize: "0.8rem", padding: "0.2rem" }}>
                  {data[value]}
                </span>
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default SlideWorkout;
